import React from 'react';
import paysysLogo from '../../../img/paysys-logo.png';

class FieldCheckbox extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            value: 'N',
            isImg: props.item.property_id === 'ORDER_PROP_6'
        };

        this._onClick = this._onClick.bind(this);
    }

    _onClick() {
        this.setState({value: this.state.value === "Y" ? "N" : "Y"});
    }

    render() {
        const {item} = this.props;
        const autofocus = (item.id === "1");

        const req = (item.req === "Y") ? "_req" : "";
        const required_sign = (item.req === "Y") ? <sup>*</sup> : '';

        const filled = (this.state.value)? 'is-not-empty' :'';
        const checked = this.state.value === "Y";
        const isImg = this.props.item.property_id === 'ORDER_PROP_6';

        return (
            <div className="order-props__prop-item">
                <div className="form-control"
                     onClick={this._onClick}
                >
                    <input type="checkbox"
                           className={req + ' '+ filled}
                           autoFocus={autofocus}
                           checked={checked}
                           onChange={this._onClick}
                    />
                    <label htmlFor={item.property_id}>{item.name} {required_sign}</label>
                    <input type="hidden"
                           name={item.property_id}
                           id={item.property_id}
                           value={this.state.value}
                    />
                    {isImg && <img src={paysysLogo}/>}
                </div>
            </div>
        );
    }
}

export default FieldCheckbox